import React, { forwardRef } from "react";
import tinycolor from "tinycolor2";

import styled from "styled-components";
import { Icon } from "./Icon";
import { themeColors } from "../react/sharedStyles";

export const WidgetButtonPosition = {
    CORNER: "corner",
    INNER: "inner",
    OUTER: "outer"
};

const Container = styled.div.attrs(({ left, top, disabled }) => ({
    style: {
        left: typeof left === "number" ? `${left}px` : left,
        top: typeof top === "number" ? `${top}px` : top,
        opacity: disabled ? 0.5 : 1
    }
}))`
    position: absolute;

    transform: translate(-50%, -50%);
    z-index: 1;

    width: 16px;
    height: 16px;

    cursor: ${({ cursor, disabled }) => disabled ? "not-allowed" : cursor};

    display: flex;
    justify-content: center;
    align-items: center;

    background: ${props => props.color ? props.color : themeColors.ui_blue};
    border-radius: 50%;
    outline: ${props => props.borderColor ? `solid 1px ${props.borderColor}` : "none"};

    pointer-events: all;
    
    .bai-icon {
        color: white !important;
        font-size: 12px;
    }

    > span {
        color: ${({ outlined }) => outlined ? "#ffffff" : "#50bbe6"};
        font-size: 15px;
    }

    &:hover {
        > span {
            color: #ffffff;
        }
        background: ${({ outlined, hoverColor, color }) => outlined ? hoverColor : (color ? tinycolor(color).darken(0.2) : "#50bbe6") };;
    }


    &:before {
        position: absolute;
        top: ${({ mousePadding }) => -mousePadding / 2}px;
        left: ${({ mousePadding }) => -mousePadding / 2}px;
        content: "";
        border-radius: 50%;
        background: rgba(255,0,0,0);
        width: ${({ mousePadding }) => mousePadding + 18}px;
        height: ${({ mousePadding }) => mousePadding + 18}px;
    }
`;

const WidgetButton = forwardRef(function RoundIconButton({ className, cursor = "pointer", color, borderColor, hoverColor = "#50bbe6", onMouseDown, mousePadding = 5, onClick, left, top, icon, outlined = false, disabled = false }, ref) {
    return (
        <Container className={className} onClick={onClick} onMouseDown={onMouseDown} color={color} borderColor={borderColor} hoverColor={hoverColor} left={left} top={top} outlined={outlined} ref={ref} cursor={cursor} mousePadding={mousePadding} disabled={disabled}>
            <Icon>{icon}</Icon>
        </Container>
    );
});

export default WidgetButton;
